'use strict'

import React from 'react';

import FormattedContent from '../components/FormattedContent.jsx';

export default class ReportSection extends React.Component {
  render() {
    return (this.props.optionalIfEmpty===true &&
      ( this.props.value===undefined || this.props.value.trim().length===0
        || this.props.value==="<p></p>" || this.props.value==="<ul></ul>" ))
      ? null
      : (
      <div style={{display:"table", width:"100%", marginTop:15, paddingTop:15, borderCollapse:"collapse", border:"solid 1px #4472C4"}}>
        <div style={{display:"table-row", backgroundColor:"#4472C4", color:"white", fontWeitgh:"bold"}}>
          <div style={{display:"table-cell", width:"100%", padding:5}}>
            {this.props.label}
          </div>
        </div>
        <div style={{display:"table-row"}}>
          <div style={{display:"table-cell"}}>
            <div style={{padding:5, paddingBottom:15}}>
              <FormattedContent value={this.props.value}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/log/ReportSection.jsx